import { render } from "./UserInfo.vue?vue&type=template&id=23cc301c&scoped=true"
const script = {}

import "./UserInfo.vue?vue&type=style&index=0&id=23cc301c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cc301c"]])

export default __exports__